import React from "react";

// Helper function to generate placeholder paths
const generatePath = (text) => {
  return `/${text.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
};

/* -------- Footer Column -------- */
const FooterColumn = ({ title, items }) => (
  <div>
    <h4 className="font-semibold mb-4 text-[#00F5A0]">{title}</h4>
    <ul className="space-y-2 text-white/70">
      {items.map((item, i) => (
        <li key={i}>
          {/* List items ko <a> tag mein badal diya gaya hai */}
          <a
            href={generatePath(item)} // Placeholder path generate kiya
            className="hover:text-white transition cursor-pointer"
          >
            {item}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer
      className="text-white pt-16 px-6 md:px-20"
      style={{ backgroundColor: "#0B0E11" }}
    >
      {/* Top Divider */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-[#00F5A0] to-transparent mb-14" />

      {/* Main Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
        {/* Brand / Description */}
        <div>
          <h3 className="text-xl font-bold mb-4">
            <span className="text-white">Craft</span>
            <span className="text-[#00F5A0]">Tech</span>
          </h3>

          <p className="text-white/70 leading-relaxed mb-6">
            Crafting exceptional digital experiences through
            precision engineering and modern design.
          </p>

          {/* Social Icons (Font Awesome assumes imported) */}
          <div className="flex gap-3">
            {[
              { icon: "fab fa-whatsapp", link: "https://wa.me/923322497267" },
              { icon: "fab fa-facebook-f", link: "https://www.facebook.com/crafttech.io" },
              { icon: "fab fa-instagram", link: "https://www.instagram.com/crafttech.io/" },
              { icon: "fab fa-linkedin-in", link: "https://www.linkedin.com/company/crafttechio/" },
            ].map((item, i) => (
              <a
                key={i}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  w-10 h-10 flex items-center justify-center rounded-full
                  bg-white/5 text-white/80
                  hover:text-black
                  hover:bg-[#00F5A0]
                  hover:shadow-[0_0_12px_rgba(0,245,160,0.6)]
                  transition-all duration-300
                "
              >
                {/* Ensure Font Awesome icons are accessible */}
                <i className={`${item.icon} text-lg`} />
              </a>
            ))}
          </div>
        </div>

        {/* Links */}
        <FooterColumn
          title="Services"
          items={["Web Development", "Mobile Apps", "UI/UX Design", "Consulting"]}
        />

        <FooterColumn
          title="Company"
          // Blog ko /blog/ path de diya hai
          items={["About Us", "Careers", "Blog", "Portfolio", "Contact"]} 
        />

        <FooterColumn
          title="Legal"
          items={["Privacy Policy", "Terms of Service", "Cookie Policy"]}
        />
      </div>

      {/* Bottom Bar */}
      <div className="mt-14 py-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-white/50">
        <p className="order-2 md:order-1 mt-3 md:mt-0">
          © {new Date().getFullYear()} Craft Tech. All rights reserved.
        </p>
        <p className="order-1 md:order-2">
          {/* 'Built by' text ko thoda visible aur clickable banaya */}
          Designed and Built by 
          <a 
            href={generatePath("Home")} // Replace with your main URL or About page
            className="text-[#00F5A0] hover:text-white transition ml-1 font-medium"
          >
            Craft Tech
          </a>
        </p>
      </div>
    </footer>
  );
}